(function() {
	// Track input method (mouse vs keyboard)
	var usingKeyboard = false;

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Tab') {
			usingKeyboard = true;
		}
	});

	document.addEventListener('mousedown', function() {
		usingKeyboard = false;
	});

	document.addEventListener('focusin', function(e) {
		if (usingKeyboard) {
			e.target.classList.add('keyboard-nav');
		} else {
			e.target.classList.remove('keyboard-nav');
		}
	});

	document.addEventListener('focusout', function(e) {
		e.target.classList.remove('keyboard-nav');
	});
})();
